<div class="container">
  <a class="logo" routerLink="home">
    <img src="assets/mock/header/logo.svg" alt="logo" />
  </a>

  <app-main-menu [menuItems]="menuItems()"></app-main-menu>

  <mat-icon class="menu-icon" (click)="toggleMobileMenu()">{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
</div>

@if (mobileMenuOpen) {
<app-mobile-main-menu [menuItems]="menuItems()" (menuItemSelect)="toggleMobileMenu()"></app-mobile-main-menu>
}
